import CryptoJS from 'crypto-js';
import { aesIv, aesKey, ENCRYPTION_ALGORITHM } from '../utils/constants';

/**
  * Encrypt sensitive data using AES encryption
  * @param {string} plainText - The plain text to encrypt
  * @returns {string} Encrypted text
  * @throws {Error} If encryption fails
  */

export const getEncryptionConfig = () => {
    return {
        specialKey: aesKey,
        iv: aesIv,
        algorithm: ENCRYPTION_ALGORITHM
    };
}

export const encrypt = (plainText) => {
    try {
        if (!plainText || plainText === null || plainText === undefined) {
            return plainText;
        }

        // Convert to string if not already
        const textToEncrypt = String(plainText);

        const encryptionConfig = getEncryptionConfig();

        if (!encryptionConfig.specialKey || !encryptionConfig.iv) {
            throw new Error('Encryption configuration missing: SPECIAL_KEY and ENCRYPTION_IV required');
        }

        const key = CryptoJS.enc.Utf8.parse(encryptionConfig.specialKey);
        const iv = CryptoJS.enc.Utf8.parse(encryptionConfig.iv.substring(0, 16));

        const encrypted = CryptoJS.AES.encrypt(textToEncrypt, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return encrypted.toString();
    } catch (error) {
        throw new Error('Failed to encrypt data');
    }
}

/**
 * Decrypt encrypted data using AES encryption
 * @param {string} encryptedText - The encrypted text to decrypt
 * @returns {string} Decrypted plain text
 * @throws {Error} If decryption fails
 */

export const decrypt = (encryptedText) => {
    try {
        if (!encryptedText || encryptedText === null || encryptedText === undefined) {
            return encryptedText;
        }

        const encryptionConfig = getEncryptionConfig();

        if (!encryptionConfig.specialKey || !encryptionConfig.iv) {
            throw new Error('Encryption configuration missing: SPECIAL_KEY and ENCRYPTION_IV required');
        }

        const key = CryptoJS.enc.Utf8.parse(encryptionConfig.specialKey);
        const iv = CryptoJS.enc.Utf8.parse(encryptionConfig.iv.substring(0, 16));

        const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

        if (!decryptedText) {
            throw new Error('Decryption resulted in empty string');
        }

        return decryptedText;
    } catch (error) {
        throw new Error('Failed to decrypt data');
    }
}


